export default class openModal {
    constructor() {
        this.openModalButtons = document.querySelectorAll('.js-open-modal');
        this.modalOuter = document.querySelector('.modal-outer');
        this.closeModalButtons = document.querySelectorAll('.js-close-modal');

        this.openModalButtons.forEach(button =>
            button.addEventListener('click', this.handleButtonClick.bind(this)),
        );

        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });

        this.modalOuter.addEventListener('click', (e) => {
            const isOutside = !e.target.closest('.modal-inner');
            if (isOutside) {
                this.closeModal();
            }
        });

        this.closeModalButtons.forEach(button =>
            button.addEventListener('click', () => {
                this.closeModal();
            }),
        );

        window.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.closeModal();
            }
        });
    }

    enableScrollLock() {
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;
    }

    disableScrollLock() {
        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    handleButtonClick() {
        this.modalOuter.classList.add('open');
        this.enableScrollLock();
    }

    closeModal() {
        this.disableScrollLock();
        this.modalOuter.classList.remove('open');
    }
}